import React, { useEffect, useMemo, useState } from "react";
import LayerAdmin from "../LayerAdmin";
import PaginationSearch from "../components/PaginationAndSearch";
import CustomerTable from "../components/CustomersTable";
import { getAllCustomers } from "../api/Customers";
import { useNavigate } from "react-router-dom";
import URL_MAPPING from "../../../routes/constants";
import { toast, ToastContainer } from "react-toastify";
import { useDebounce } from "../hooks/debounce";

const Customers = () => {
  const [tableData, setTableData] = useState<any>({});
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState("");
  const navigate = useNavigate();

  const debounce = useDebounce(search);

  const getTableData = async () => {
    try {
      setLoading(true);
      const paramsObject: {
        search?: string;
      } = {};
      if (search.length > 0) paramsObject.search = search;
      const response = await getAllCustomers(page, 20, paramsObject);
      if (!response || !Array.isArray(response.items)) {
        toast.error("Invalid or empty customer response");
        console.warn("Invalid or empty customer response:", response);
        setTableData({ items: [], page: 1, size: 20, total: 0 });
        return;
      }
      setTableData(response);
      setPage(response.page ?? 1);
    } catch (error: any) {
      console.error("Error fetching customer data:", error);
      if (error?.response?.status === 404) {
        toast.error("Route not found, Please try again later");
      } else if (error?.response?.status === 500) {
        toast.error("Error while fetching the customer");
      } else {
        const detail = error?.response?.data?.detail;
        if (Array.isArray(detail)) {
          detail.forEach((err) => toast.error(err.msg));
        } else {
          toast.error(detail?.msg || detail || "An unexpected error occurred.");
        }
      }
    } finally {
      setLoading(false);
    }
  };

  const handlePaginationNext = () => {
    if (loading) return;
    setPage((prev) => prev + 1);
  };

  const handlePaginationPrev = () => {
    if (loading) return;
    setPage((prev) => Math.max(prev - 1, 1));
  };

  const handleEditCustomer = (id: string) => {
    navigate(URL_MAPPING.EDITCUSTOMER(id));
  };

  const totalPages = useMemo(() => {
    if (!tableData?.total || !tableData?.size) return 0;
    return Math.ceil(tableData.total / tableData.size);
  }, [tableData?.total, tableData?.size]);

  useEffect(() => {
    getTableData();
  }, [page, debounce]);
  return (
    <LayerAdmin>
      <ToastContainer />
      <PaginationSearch
        page={tableData.page}
        size={totalPages}
        handlePaginationNext={handlePaginationNext}
        handlePaginationPrev={handlePaginationPrev}
        search={search}
        setSearch={setSearch}
        placeholder="Search By Customer ID"
      />
      <div className="flex items-center px-5 pb-5 gap-3">
        <h3 className="text-xl font-bold text-gray-700">Customers</h3>
      </div>
      <CustomerTable
        tableData={tableData}
        loading={loading}
        handleEditCustomer={handleEditCustomer}
      />
    </LayerAdmin>
  );
};

export default Customers;
